<template>
  <div>
    <form class="social-form">
      <custom-input
        required
        inputType="string"
        placeholder="Название"
        labelText="Название"
        v-model="social.name"
        :errorMessage="errors['name'] ? errors['name'][0] : ''"
        :inputValue="social.name"
        name="name"
      />

      <custom-input
        v-if="social.type == 3 || social.type == 4"
        inputType="number"
        placeholder="Интенсивность движения, авт.\сутки"
        labelText="Интенсивность движения, авт.\сутки"
        v-model="social.intensity"
        :errorMessage="errors['intensity'] ? errors['intensity'][0] : ''"
        :inputValue="social.intensity"
        name="intensity"
      />

      <custom-input
        v-if="social.type == 3 || social.type == 4"
        inputType="number"
        placeholder="Скорость движения, км\ч:"
        labelText="Скорость движения, км\ч:"
        v-model="social.speed"
        :errorMessage="errors['speed'] ? errors['speed'][0] : ''"
        :inputValue="social.speed"
        name="speed"
      />

      <custom-input
        v-if="social.type == 3 || social.type == 4"
        inputType="number"
        placeholder="Количество человек в транспорте:"
        labelText="Количество человек в транспорте:"
        v-model="social.perosns_in_transport"
        :errorMessage="errors['perosns_in_transport'] ? errors['perosns_in_transport'][0] : ''"
        :inputValue="social.perosns_in_transport"
        name="perosns_in_transport"
      />

      <custom-input
        v-if="social.type == 1 || social.type == 2"
        inputType="number"
        placeholder="Введите количество человек"
        labelText="Введите количество человек"
        v-model="social.count_of_persons"
        :errorMessage="errors['count_of_persons'] ? errors['count_of_persons'][0] : ''"
        :inputValue="social.count_of_persons"
        name="count_of_persons"
      />

      <custom-input
        v-if="social.type == 2"
        inputType="number"
        placeholder="Время пребывания людей, ч"
        labelText="Время пребывания людей (количество часов в сутки), ч:"
        v-model="social.hours"
        :errorMessage="errors['hours'] ? errors['hours'][0] : ''"
        :inputValue="social.hours"
        name="hours"
      />
    </form>

    <div class="modal-footer-buttons">
      <main-button type="button" @click="save()">Сохранить</main-button>
      <main-button color="link" type="button" @click="$emit('onCancelClick')">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import MainButton from "../../../components/ui/MainButton.vue";
import CustomInput from "../../../components/ui/Input.vue";
export default {
  components: { MainButton, CustomInput },
  name: "socialAdd",
  props: {
    project: Object,
    social: Object,
    socials: Array,
    cur_index: Number,
  },
  data() {
    return {
      errors: [],
    };
  },
  methods: {
    save() {
      if (!this.social.id) {
        this.$http
          .post("risk/socials/create?proj_id=" + this.project.id, this.social)
          .then((response) => {
            this.socials.unshift(response.data);
            this.$emit("socialCreated");
          })
          .catch((e) => {
            if (e.response.data) {
              this.errors = e.response.data;
            }
          });
      } else {
        this.$http
          .post("risk/socials/update?proj_id=" + this.project.id + "&id=" + this.social.id, this.social)
          .then(() => {
            this.$emit("socialEditHide");
          })
          .catch((e) => {
            if (e.response.data) {
              this.errors = e.response.data;
            }
          });
      }
    },
  },
  mounted() {
    if (!this.social.id) {
      this.$set(this.social, "count_of_persons", undefined);
      this.$set(this.social, "hours", undefined);
      this.$set(this.social, "name", undefined);
      this.$set(this.social, "intensity", undefined);
      this.$set(this.social, "perosns_in_transport", undefined);
      this.$set(this.social, "speed", undefined);
    }
  },
};
</script>

<style scoped>
.social-form {
  padding: 0 24px;
}
</style>
